import React, { Component } from "react";
import Header from '../components/landing/HeaderComponent';
import HWStepComponent from '../components/landing/HWStepComponent';
import Footer from '../components/landing/FooterComponent';
import Video from '../components/Video';

export default class Landing extends Component {


  render() {

    const howItWorksSteps = [
      {
        stepCount: '1',
        coverAlignment: 'left',
        coverClass: 'purple-cover',
        contentImage: require('../assets/images/mac-step1.png'),
        stepTitle: 'Create a wormhole',
        stepDescription: 'Search our database by entering a word, phrase, or series of words to see if it is available.  Select the US States (or all) where you want the wormhole to be active.'
      },
      {
        stepCount: '2',
        coverAlignment: 'right',
        coverClass: 'red-cover',
        contentImage: require('../assets/images/mac-step2.png'),
        stepTitle: 'Lease the wormhole or bid on one that is currently leased',
        stepDescription: 'Choose to lease the wormhole. If it is currently leased, you can use our auction system to try and assume the lease at the end of its term.'
      },
      {
        stepCount: '3',
        coverAlignment: 'left',
        coverClass: 'purple-cover',
        contentImage: require('../assets/images/mac-step3.png'),
        stepTitle: 'Determine the destination for the wormhole',
        stepDescription: 'You can choose any destination website for your users when they speak your wormhole into their device. You specify the destination for users in each state where your wormhole is active. It could be your home page, landing page, a promo page with a coupon, a customer support 800 number, etc.'
      },
      {
        stepCount: '4',
        coverAlignment: 'right',
        coverClass: 'red-cover',
        contentImage: require('../assets/images/iphone-step4.png'),
        stepTitle: 'Market your wormhole',
        stepDescription: 'Simply tell your customers through your means of advertising what your wormhole is instead of a cumbersome web address, phone number, etc.',
        appStoreBlock: true
      },
      {
        stepCount: '5',
        coverAlignment: 'left',
        coverClass: 'purple-cover',
        contentImage: require('../assets/images/mac-step5.png'),
        stepTitle: 'Watch your traffic increase',
        stepDescription: 'Users will speak your wormhole into the Vocalize app and be delivered right to your doorstep.'
      }
    ];
    const bannerVideo = {
      source: 'https://s3-us-west-1.amazonaws.com/www.vocalizemysite.com/static/videos/vocalize-banner-video.m4v',
      thumbnail: 'https://s3-us-west-1.amazonaws.com/www.vocalizemysite.com/static/thumbs/vocalize-banner-thumb.png'
    };

    return (
      <div>
        <Header history={this.props.history}/>
        <section className="banner-section">
          <div className="container-fluid">
            <div className="info-row">
              <div className="info-col">
                <p className="description">
                  Are you tired of wasting marketing dollars when someone searches for your site, only to be pulled away by a competitor?
                </p>
                <p className="description">
                  Do you wish there was a better way for customers and prospects to get to the site you want without having to remember <span className="external-link">http://YourWebSite.com/PromoCode</span>?
                </p>
                <h2 className="banner-title">Vocalize changes the landscape in marketing</h2>
                <a onClick={()=> {this.props.history.push('signup')}} className="banner-action">GET MY WORMHOLE</a>
              </div>
              <div className="display-col">
                <Video wrapperClass='banner-video' source={bannerVideo.source} thumbnail={bannerVideo.thumbnail} />
              </div>
            </div>
          </div>
        </section>
        <section className="about-section">
          <span className="section-overlay"></span>
          <div className="container section-content">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="section-title">With Vocalize, you create a “wormhole”,</h2>
                <p className="description">
                  a unique word or phrase that you associate with a distinct website or phone number of your choice in our service. When
                  your customer says the word or phrase into our app, they are delivered right to that site - eliminating the
                  chance of competitors SEO stealing your traffic.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="how-it-works">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="section-title">Here’s how it works:</h2>
              </div>
            </div>
            <HWStepComponent stepsArr={howItWorksSteps} />
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Landing.js